// Phone hamburger menu: toggles data-open (CSS drives the icon morph and panel slide),
// keeps aria-expanded/inert in sync, and closes on link tap, Escape, outside tap, or desktop width.
class MobileMenu extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.toggle = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('#mobile-menu-panel');
    if (!this.toggle || !this.panel) return;

    this.toggle.addEventListener('click', () => this.setOpen(!this.hasAttribute('data-open')), { signal });
    this.panel.addEventListener('click', (event) => {
      if (event.target.closest('a, [data-menu-close]')) this.setOpen(false);
    }, { signal });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('data-open')) {
        this.setOpen(false);
        this.toggle.focus();
      }
    }, { signal });
    document.addEventListener('click', (event) => {
      if (this.hasAttribute('data-open') && !this.contains(event.target)) this.setOpen(false);
    }, { signal });
    const desktop = window.matchMedia('(min-width: 48rem)');
    desktop.addEventListener('change', (event) => { if (event.matches) this.setOpen(false); }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  setOpen(open) {
    this.toggleAttribute('data-open', open);
    this.toggle.setAttribute('aria-expanded', String(open));
    this.panel.inert = !open;
  }
}

if (!customElements.get('s-mobile-menu')) customElements.define('s-mobile-menu', MobileMenu);
